module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.error
    }
  }, [(_vm.label) ? _c('label', {
    staticClass: "text-info",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "input-group-btn"
  }, [_c('span', {
    staticClass: "btn btn-primary"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-upload"
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": _vm.multiple,
      "name": _vm.name,
      "required": _vm.required
    },
    on: {
      "click": function($event) {
        return _vm.onClick($event.target)
      },
      "change": function($event) {
        return _vm.onChange($event.target.files)
      }
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fileText),
      expression: "fileText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder,
      "readonly": ""
    },
    domProps: {
      "value": (_vm.fileText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fileText = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.error) ? _c('span', {
    staticClass: "help-block",
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d87d2b3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/inputs/InputFile.vue
// module id = 958
// module chunks = 34